// A treaty another house offers you: the terms, and the two answers.
//
// Like the merchant and marriage offers it lives in the snapshot
// (`globals.diplomacy`): once answered or expired it leaves, with no event to miss.
import { Button } from '@aod/ui/components/ui/button';
import { ScrollText } from 'lucide-react';
import type { TreatyOffer } from '../dynasty/diplomacy.js';
import { useT } from '../i18n/index.js';
import { appDom } from '../lib/appDom.js';

export function TreatyOfferToast({
  offer,
  fromName,
  onAccept,
  onDecline,
}: {
  /** The oldest offer waiting on you; null when none is. */
  readonly offer: TreatyOffer | null;
  readonly fromName: string;
  readonly onAccept: (from: number) => void;
  readonly onDecline: (from: number) => void;
}) {
  const t = useT();
  if (!offer) return null;
  return (
    <div
      data-testid="treaty-offer-toast"
      {...appDom({ id: 'treaty-offer-toast', type: 'Toast', scope: 'toast' })}
      className="pointer-events-auto flex w-full max-w-[min(92vw,460px)] flex-wrap items-center gap-3 rounded-xl border border-emerald-500/50 bg-panel-scrim px-4 py-2.5 text-left text-foreground shadow-[0_0_24px_rgba(110,220,160,0.14)] backdrop-blur-sm dark:shadow-[0_0_30px_rgba(110,220,160,0.2)]"
    >
      <ScrollText
        className="size-5 shrink-0 text-emerald-600 dark:text-emerald-400"
        aria-hidden="true"
      />
      <span className="min-w-[10rem] flex-1 font-serif text-sm leading-tight text-emerald-700 dark:text-emerald-300">
        {t('treaty.offerTitle', { house: fromName, treaty: t(`treaty.of.${offer.state}`) })}
      </span>
      <span className="flex shrink-0 gap-2">
        <Button type="button" size="sm" onClick={() => onAccept(offer.from)}>
          {t('treaty.accept')}
        </Button>
        <Button type="button" size="sm" variant="outline" onClick={() => onDecline(offer.from)}>
          {t('treaty.decline')}
        </Button>
      </span>
    </div>
  );
}
